import apiClient from './apiClient';

export interface DailyRecordScaffoldTeamResult {
  team: { id: string; name: string; teamType: string };
  dispatchTaskCount: number;
  workerCount: number;
  dfr: { id: string; status: string; created: boolean };
  timesheet: { id: string; status: string; created: boolean };
  inspections: Array<{ id: string; inspectionNumber: string; status: string; created: boolean }>;
}

export interface DailyRecordScaffoldResult {
  projectId: string;
  recordDate: string;
  dispatchCount: number;
  teams: DailyRecordScaffoldTeamResult[];
  totals: {
    teams: number;
    dispatchTasks: number;
    workers: number;
    inspections: number;
  };
}

const unwrap = <T>(response: any): T => response?.data ?? response;

class DailyRecordScaffoldService {
  async scaffold(projectId: string, recordDate: string): Promise<DailyRecordScaffoldResult> {
    const response = await apiClient.post('/daily-record-scaffolds', { projectId, recordDate });
    return unwrap<DailyRecordScaffoldResult>(response);
  }
}

export default new DailyRecordScaffoldService();
